// Comprehensive US State Tax Data 2024/2025
// Includes all 50 states + DC with accurate tax rates, brackets, and special rules

export const US_STATES = {
  AL: { code: 'AL', name: 'Alabama', abbreviation: 'AL' },
  AK: { code: 'AK', name: 'Alaska', abbreviation: 'AK' },
  AZ: { code: 'AZ', name: 'Arizona', abbreviation: 'AZ' },
  AR: { code: 'AR', name: 'Arkansas', abbreviation: 'AR' },
  CA: { code: 'CA', name: 'California', abbreviation: 'CA' },
  CO: { code: 'CO', name: 'Colorado', abbreviation: 'CO' },
  CT: { code: 'CT', name: 'Connecticut', abbreviation: 'CT' },
  DE: { code: 'DE', name: 'Delaware', abbreviation: 'DE' },
  DC: { code: 'DC', name: 'District of Columbia', abbreviation: 'DC' },
  FL: { code: 'FL', name: 'Florida', abbreviation: 'FL' },
  GA: { code: 'GA', name: 'Georgia', abbreviation: 'GA' },
  HI: { code: 'HI', name: 'Hawaii', abbreviation: 'HI' },
  ID: { code: 'ID', name: 'Idaho', abbreviation: 'ID' },
  IL: { code: 'IL', name: 'Illinois', abbreviation: 'IL' },
  IN: { code: 'IN', name: 'Indiana', abbreviation: 'IN' },
  IA: { code: 'IA', name: 'Iowa', abbreviation: 'IA' },
  KS: { code: 'KS', name: 'Kansas', abbreviation: 'KS' },
  KY: { code: 'KY', name: 'Kentucky', abbreviation: 'KY' },
  LA: { code: 'LA', name: 'Louisiana', abbreviation: 'LA' },
  ME: { code: 'ME', name: 'Maine', abbreviation: 'ME' },
  MD: { code: 'MD', name: 'Maryland', abbreviation: 'MD' },
  MA: { code: 'MA', name: 'Massachusetts', abbreviation: 'MA' },
  MI: { code: 'MI', name: 'Michigan', abbreviation: 'MI' },
  MN: { code: 'MN', name: 'Minnesota', abbreviation: 'MN' },
  MS: { code: 'MS', name: 'Mississippi', abbreviation: 'MS' },
  MO: { code: 'MO', name: 'Missouri', abbreviation: 'MO' },
  MT: { code: 'MT', name: 'Montana', abbreviation: 'MT' },
  NE: { code: 'NE', name: 'Nebraska', abbreviation: 'NE' },
  NV: { code: 'NV', name: 'Nevada', abbreviation: 'NV' },
  NH: { code: 'NH', name: 'New Hampshire', abbreviation: 'NH' },
  NJ: { code: 'NJ', name: 'New Jersey', abbreviation: 'NJ' },
  NM: { code: 'NM', name: 'New Mexico', abbreviation: 'NM' },
  NY: { code: 'NY', name: 'New York', abbreviation: 'NY' },
  NC: { code: 'NC', name: 'North Carolina', abbreviation: 'NC' },
  ND: { code: 'ND', name: 'North Dakota', abbreviation: 'ND' },
  OH: { code: 'OH', name: 'Ohio', abbreviation: 'OH' },
  OK: { code: 'OK', name: 'Oklahoma', abbreviation: 'OK' },
  OR: { code: 'OR', name: 'Oregon', abbreviation: 'OR' },
  PA: { code: 'PA', name: 'Pennsylvania', abbreviation: 'PA' },
  RI: { code: 'RI', name: 'Rhode Island', abbreviation: 'RI' },
  SC: { code: 'SC', name: 'South Carolina', abbreviation: 'SC' },
  SD: { code: 'SD', name: 'South Dakota', abbreviation: 'SD' },
  TN: { code: 'TN', name: 'Tennessee', abbreviation: 'TN' },
  TX: { code: 'TX', name: 'Texas', abbreviation: 'TX' },
  UT: { code: 'UT', name: 'Utah', abbreviation: 'UT' },
  VT: { code: 'VT', name: 'Vermont', abbreviation: 'VT' },
  VA: { code: 'VA', name: 'Virginia', abbreviation: 'VA' },
  WA: { code: 'WA', name: 'Washington', abbreviation: 'WA' },
  WV: { code: 'WV', name: 'West Virginia', abbreviation: 'WV' },
  WI: { code: 'WI', name: 'Wisconsin', abbreviation: 'WI' },
  WY: { code: 'WY', name: 'Wyoming', abbreviation: 'WY' }
};

// ============================================================================
// Comprehensive State Income Tax Configuration
// Updated for Tax Year 2024/2025
// ============================================================================

export const STATE_TAX_CONFIG = {
  // ============ NO STATE INCOME TAX ============
  AK: {
    name: 'Alaska',
    hasStateTax: false,
    notes: 'Alaska has no state income tax',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  FL: {
    name: 'Florida',
    hasStateTax: false,
    notes: 'Florida has no state income tax',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  NV: {
    name: 'Nevada',
    hasStateTax: false,
    notes: 'Nevada has no state income tax',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  NH: {
    name: 'New Hampshire',
    hasStateTax: false,
    notes: 'New Hampshire has no wage income tax (only taxes interest and dividends, being phased out)',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  SD: {
    name: 'South Dakota',
    hasStateTax: false,
    notes: 'South Dakota has no state income tax',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  TN: {
    name: 'Tennessee',
    hasStateTax: false,
    notes: 'Tennessee has no wage income tax (Hall Tax on investments was fully repealed in 2021)',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  TX: {
    name: 'Texas',
    hasStateTax: false,
    notes: 'Texas has no state income tax',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  WA: {
    name: 'Washington',
    hasStateTax: false,
    notes: 'Washington has no state income tax on wages (has capital gains tax)',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.0058, // Combined employee + employer
      pfmlEmployeeRate: 0.0058 * 0.7273, // ~72.73% employee share
      pfmlEmployerRate: 0.0058 * 0.2727,
      localTaxCommon: false
    }
  },
  WY: {
    name: 'Wyoming',
    hasStateTax: false,
    notes: 'Wyoming has no state income tax',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },

  // ============ FLAT TAX STATES ============
  AZ: {
    name: 'Arizona',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.025, // 2.5% (reduced from 2.59% in 2023)
    standardDeduction: {
      single: 14600,
      married: 29200,
      headOfHousehold: 21900
    },
    exemptions: {
      personal: 0, // Arizona uses standard deduction only
      dependent: 100 // Per dependent tax credit
    },
    notes: 'Flat 2.5% rate effective 2024',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  CO: {
    name: 'Colorado',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.044, // 4.4% (reduced from 4.55%)
    standardDeduction: {
      single: 14600, // Tied to federal
      married: 29200,
      headOfHousehold: 21900
    },
    notes: 'Colorado uses federal taxable income as base. 4.4% flat rate for 2024.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.009,
      pfmlEmployeeRate: 0.0045,
      pfmlEmployerRate: 0.0045,
      pfmlWageBase: 167700,
      localTaxCommon: false
    }
  },
  GA: {
    name: 'Georgia',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0549, // 5.49% (transitioning to flat tax)
    standardDeduction: {
      single: 12000,
      married: 24000,
      headOfHousehold: 18000
    },
    exemptions: {
      personal: 2700,
      dependent: 3000
    },
    notes: 'Georgia transitioned to flat tax in 2024. Rate decreases planned.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  ID: {
    name: 'Idaho',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.058, // 5.8%
    standardDeduction: {
      single: 14600, // Tied to federal
      married: 29200,
      headOfHousehold: 21900
    },
    notes: 'Idaho moved to flat tax in 2023',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  IL: {
    name: 'Illinois',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0495, // 4.95%
    exemptions: {
      personal: 2625, // Per exemption (includes self)
      dependent: 2625
    },
    notes: 'Illinois flat tax with no standard deduction, only personal exemptions',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  IN: {
    name: 'Indiana',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0305, // 3.05% (reduced for 2024)
    exemptions: {
      personal: 1000,
      dependent: 1500,
      additionalFor65: 1000,
      additionalForBlind: 1000
    },
    notes: 'Indiana has county-level local taxes (0.5% - 3.38%)',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'county',
      localTaxRange: { min: 0.005, max: 0.0338 }
    }
  },
  IA: {
    name: 'Iowa',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.057, // 5.7% (transitioning, was progressive)
    standardDeduction: {
      single: 0, // Iowa doesn't have standard deduction
      married: 0
    },
    notes: 'Iowa transitioning to flat tax. Federal deduction allowed.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'school district',
      localTaxRange: { min: 0, max: 0.02 }
    }
  },
  KY: {
    name: 'Kentucky',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.04, // 4% (reduced from 4.5%)
    standardDeduction: {
      single: 3160,
      married: 6320,
      headOfHousehold: 3160
    },
    notes: 'Kentucky flat tax reduced to 4% for 2024',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city/county',
      localTaxRange: { min: 0.01, max: 0.025 }
    }
  },
  MA: {
    name: 'Massachusetts',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.05, // 5% standard rate
    additionalRate: 0.04, // 4% millionaires tax
    additionalThreshold: 1000000, // Income over $1M
    exemptions: {
      personal: 4400, // Single
      personalMarried: 8800,
      dependent: 1000,
      additionalFor65: 700,
      additionalForBlind: 2200
    },
    notes: 'Massachusetts has 4% surtax on income over $1M effective 2023',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.0088,
      pfmlEmployeeRate: 0.00318,
      pfmlEmployerRate: 0.00562,
      pfmlWageBase: 168600,
      localTaxCommon: false
    }
  },
  MI: {
    name: 'Michigan',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0425, // 4.25%
    exemptions: {
      personal: 5400,
      dependent: 5400
    },
    notes: 'Michigan has some cities with local income tax (Detroit, Grand Rapids, etc.)',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city',
      localTaxRange: { min: 0.005, max: 0.024 }
    }
  },
  MS: {
    name: 'Mississippi',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.05, // 5% on income over $10,000
    standardDeduction: {
      single: 2300,
      married: 4600,
      headOfHousehold: 3400
    },
    exemptions: {
      personal: 6000, // Single
      personalMarried: 12000,
      dependent: 1500
    },
    brackets: [
      { min: 0, max: 10000, rate: 0 }
    ],
    notes: 'Mississippi has 0% on first $10,000, then 5% flat',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  MT: {
    name: 'Montana',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.059, // 5.9% (changed to flat in 2024)
    standardDeduction: {
      single: 5540,
      married: 11080,
      headOfHousehold: 8310
    },
    notes: 'Montana moved to flat tax in 2024',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  NC: {
    name: 'North Carolina',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0525, // 5.25% (reduced from 5.5%)
    standardDeduction: {
      single: 12750,
      married: 25500,
      headOfHousehold: 19125
    },
    notes: 'North Carolina flat tax continuing to decrease',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  ND: {
    name: 'North Dakota',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0195, // 1.95% (one of lowest in nation)
    standardDeduction: {
      single: 14600, // Tied to federal
      married: 29200,
      headOfHousehold: 21900
    },
    notes: 'North Dakota has very low flat tax rate',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  PA: {
    name: 'Pennsylvania',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0307, // 3.07%
    exemptions: {
      personal: 0 // PA has no personal exemptions
    },
    notes: 'Pennsylvania has flat tax with significant local (city/school district) taxes',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city/school',
      localTaxRange: { min: 0.01, max: 0.035 },
      localTaxNotes: 'Philadelphia has 3.79% resident rate'
    }
  },
  UT: {
    name: 'Utah',
    hasStateTax: true,
    taxType: 'flat',
    flatRate: 0.0465, // 4.65%
    standardDeduction: {
      single: 876, // Utah has small standard deduction
      married: 1752,
      headOfHousehold: 876
    },
    exemptions: {
      personal: 1820, // Taxpayer credit instead of exemption
      dependent: 607 // Dependent credit
    },
    notes: 'Utah uses credits instead of deductions/exemptions',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },

  // ============ PROGRESSIVE TAX STATES ============
  AL: {
    name: 'Alabama',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 500, rate: 0.02 },
        { min: 500, max: 3000, rate: 0.04 },
        { min: 3000, max: Infinity, rate: 0.05 }
      ],
      married: [
        { min: 0, max: 1000, rate: 0.02 },
        { min: 1000, max: 6000, rate: 0.04 },
        { min: 6000, max: Infinity, rate: 0.05 }
      ]
    },
    standardDeduction: {
      single: 2500,
      married: 7500,
      headOfHousehold: 4700
    },
    exemptions: {
      personal: 1500,
      dependent: 1000
    },
    notes: 'Alabama allows federal tax deduction',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city/county occupational',
      localTaxRange: { min: 0.01, max: 0.02 }
    }
  },
  AR: {
    name: 'Arkansas',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 4400, rate: 0.02 },
        { min: 4400, max: 8800, rate: 0.04 },
        { min: 8800, max: Infinity, rate: 0.044 }
      ],
      married: [
        { min: 0, max: 4400, rate: 0.02 },
        { min: 4400, max: 8800, rate: 0.04 },
        { min: 8800, max: Infinity, rate: 0.044 }
      ]
    },
    standardDeduction: {
      single: 2340,
      married: 4680,
      headOfHousehold: 2340
    },
    notes: 'Arkansas top rate reduced to 4.4% for 2024',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  CA: {
    name: 'California',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 10412, rate: 0.01 },
        { min: 10412, max: 24684, rate: 0.02 },
        { min: 24684, max: 38959, rate: 0.04 },
        { min: 38959, max: 54081, rate: 0.06 },
        { min: 54081, max: 68350, rate: 0.08 },
        { min: 68350, max: 349137, rate: 0.093 },
        { min: 349137, max: 418961, rate: 0.103 },
        { min: 418961, max: 698271, rate: 0.113 },
        { min: 698271, max: 1000000, rate: 0.123 },
        { min: 1000000, max: Infinity, rate: 0.133 } // Mental Health Services Tax
      ],
      married: [
        { min: 0, max: 20824, rate: 0.01 },
        { min: 20824, max: 49368, rate: 0.02 },
        { min: 49368, max: 77918, rate: 0.04 },
        { min: 77918, max: 108162, rate: 0.06 },
        { min: 108162, max: 136700, rate: 0.08 },
        { min: 136700, max: 698274, rate: 0.093 },
        { min: 698274, max: 837922, rate: 0.103 },
        { min: 837922, max: 1396542, rate: 0.113 },
        { min: 1396542, max: Infinity, rate: 0.123 }
      ]
    },
    standardDeduction: {
      single: 5363,
      married: 10726,
      headOfHousehold: 10726
    },
    exemptions: {
      personal: 144,
      dependent: 446
    },
    notes: 'California has highest state income tax rates. 1% Mental Health Services Tax on income over $1M for single filers.',
    otherTaxes: {
      sdiRequired: true,
      sdiRate: 0.009,
      sdiWageBase: 153164,
      pfmlRequired: true, // Combined with SDI
      pfmlRate: 0, // Included in SDI
      localTaxCommon: false
    }
  },
  CT: {
    name: 'Connecticut',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 10000, rate: 0.03 },
        { min: 10000, max: 50000, rate: 0.05 },
        { min: 50000, max: 100000, rate: 0.055 },
        { min: 100000, max: 200000, rate: 0.06 },
        { min: 200000, max: 250000, rate: 0.065 },
        { min: 250000, max: 500000, rate: 0.069 },
        { min: 500000, max: Infinity, rate: 0.0699 }
      ],
      married: [
        { min: 0, max: 20000, rate: 0.03 },
        { min: 20000, max: 100000, rate: 0.05 },
        { min: 100000, max: 200000, rate: 0.055 },
        { min: 200000, max: 400000, rate: 0.06 },
        { min: 400000, max: 500000, rate: 0.065 },
        { min: 500000, max: 1000000, rate: 0.069 },
        { min: 1000000, max: Infinity, rate: 0.0699 }
      ]
    },
    exemptions: {
      personal: 15000, // Single, phases out at higher income
      personalMarried: 24000,
      dependent: 0
    },
    notes: 'Connecticut has complex exemption phase-outs',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.005,
      pfmlEmployeeRate: 0.005,
      pfmlEmployerRate: 0,
      pfmlWageBase: 168600,
      localTaxCommon: false
    }
  },
  DE: {
    name: 'Delaware',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 2000, rate: 0 },
        { min: 2000, max: 5000, rate: 0.022 },
        { min: 5000, max: 10000, rate: 0.039 },
        { min: 10000, max: 20000, rate: 0.048 },
        { min: 20000, max: 25000, rate: 0.052 },
        { min: 25000, max: 60000, rate: 0.0555 },
        { min: 60000, max: Infinity, rate: 0.066 }
      ],
      married: [
        { min: 0, max: 2000, rate: 0 },
        { min: 2000, max: 5000, rate: 0.022 },
        { min: 5000, max: 10000, rate: 0.039 },
        { min: 10000, max: 20000, rate: 0.048 },
        { min: 20000, max: 25000, rate: 0.052 },
        { min: 25000, max: 60000, rate: 0.0555 },
        { min: 60000, max: Infinity, rate: 0.066 }
      ]
    },
    standardDeduction: {
      single: 3250,
      married: 6500,
      headOfHousehold: 3250
    },
    exemptions: {
      personal: 110,
      dependent: 110
    },
    notes: 'Delaware has 0% bracket for first $2,000',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true, // Starting 2026
      pfmlStartDate: '2026-01-01',
      localTaxCommon: true,
      localTaxType: 'wilmington',
      localTaxRate: 0.0125
    }
  },
  DC: {
    name: 'District of Columbia',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 10000, rate: 0.04 },
        { min: 10000, max: 40000, rate: 0.06 },
        { min: 40000, max: 60000, rate: 0.065 },
        { min: 60000, max: 250000, rate: 0.085 },
        { min: 250000, max: 500000, rate: 0.0925 },
        { min: 500000, max: 1000000, rate: 0.0975 },
        { min: 1000000, max: Infinity, rate: 0.1075 }
      ],
      married: [
        { min: 0, max: 10000, rate: 0.04 },
        { min: 10000, max: 40000, rate: 0.06 },
        { min: 40000, max: 60000, rate: 0.065 },
        { min: 60000, max: 250000, rate: 0.085 },
        { min: 250000, max: 500000, rate: 0.0925 },
        { min: 500000, max: 1000000, rate: 0.0975 },
        { min: 1000000, max: Infinity, rate: 0.1075 }
      ]
    },
    standardDeduction: {
      single: 14600,
      married: 29200,
      headOfHousehold: 21900
    },
    exemptions: {
      personal: 4150,
      dependent: 4150
    },
    notes: 'DC has high top marginal rate of 10.75%',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.0026,
      pfmlEmployeeRate: 0,
      pfmlEmployerRate: 0.0026,
      localTaxCommon: false
    }
  },
  HI: {
    name: 'Hawaii',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 2400, rate: 0.014 },
        { min: 2400, max: 4800, rate: 0.032 },
        { min: 4800, max: 9600, rate: 0.055 },
        { min: 9600, max: 14400, rate: 0.064 },
        { min: 14400, max: 19200, rate: 0.068 },
        { min: 19200, max: 24000, rate: 0.072 },
        { min: 24000, max: 36000, rate: 0.076 },
        { min: 36000, max: 48000, rate: 0.079 },
        { min: 48000, max: 150000, rate: 0.0825 },
        { min: 150000, max: 175000, rate: 0.09 },
        { min: 175000, max: 200000, rate: 0.10 },
        { min: 200000, max: Infinity, rate: 0.11 }
      ],
      married: [
        { min: 0, max: 4800, rate: 0.014 },
        { min: 4800, max: 9600, rate: 0.032 },
        { min: 9600, max: 19200, rate: 0.055 },
        { min: 19200, max: 28800, rate: 0.064 },
        { min: 28800, max: 38400, rate: 0.068 },
        { min: 38400, max: 48000, rate: 0.072 },
        { min: 48000, max: 72000, rate: 0.076 },
        { min: 72000, max: 96000, rate: 0.079 },
        { min: 96000, max: 300000, rate: 0.0825 },
        { min: 300000, max: 350000, rate: 0.09 },
        { min: 350000, max: 400000, rate: 0.10 },
        { min: 400000, max: Infinity, rate: 0.11 }
      ]
    },
    standardDeduction: {
      single: 2200,
      married: 4400,
      headOfHousehold: 3212
    },
    exemptions: {
      personal: 1144,
      dependent: 1144
    },
    notes: 'Hawaii has 12 brackets with top rate of 11%',
    otherTaxes: {
      sdiRequired: true,
      sdiRate: 0.005,
      sdiWageBase: 61700,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  KS: {
    name: 'Kansas',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 15000, rate: 0.031 },
        { min: 15000, max: 30000, rate: 0.0525 },
        { min: 30000, max: Infinity, rate: 0.057 }
      ],
      married: [
        { min: 0, max: 30000, rate: 0.031 },
        { min: 30000, max: 60000, rate: 0.0525 },
        { min: 60000, max: Infinity, rate: 0.057 }
      ]
    },
    standardDeduction: {
      single: 3500,
      married: 8000,
      headOfHousehold: 6000
    },
    exemptions: {
      personal: 2250,
      dependent: 2250
    },
    notes: 'Kansas three-bracket progressive system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city',
      localTaxRange: { min: 0, max: 0.01 }
    }
  },
  LA: {
    name: 'Louisiana',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 12500, rate: 0.0185 },
        { min: 12500, max: 50000, rate: 0.035 },
        { min: 50000, max: Infinity, rate: 0.0425 }
      ],
      married: [
        { min: 0, max: 25000, rate: 0.0185 },
        { min: 25000, max: 100000, rate: 0.035 },
        { min: 100000, max: Infinity, rate: 0.0425 }
      ]
    },
    standardDeduction: {
      single: 0, // Louisiana uses personal exemptions instead
      married: 0
    },
    exemptions: {
      personal: 4500,
      dependent: 1000
    },
    notes: 'Louisiana allows federal tax deduction. Lower rates effective 2024.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  ME: {
    name: 'Maine',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 24500, rate: 0.058 },
        { min: 24500, max: 58050, rate: 0.0675 },
        { min: 58050, max: Infinity, rate: 0.0715 }
      ],
      married: [
        { min: 0, max: 49050, rate: 0.058 },
        { min: 49050, max: 116100, rate: 0.0675 },
        { min: 116100, max: Infinity, rate: 0.0715 }
      ]
    },
    standardDeduction: {
      single: 14600,
      married: 29200,
      headOfHousehold: 21900
    },
    exemptions: {
      personal: 4700,
      dependent: 4700
    },
    notes: 'Maine three-bracket system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.01,
      pfmlEmployeeRate: 0.005,
      pfmlEmployerRate: 0.005,
      pfmlStartDate: '2024-01-01',
      localTaxCommon: false
    }
  },
  MD: {
    name: 'Maryland',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 1000, rate: 0.02 },
        { min: 1000, max: 2000, rate: 0.03 },
        { min: 2000, max: 3000, rate: 0.04 },
        { min: 3000, max: 100000, rate: 0.0475 },
        { min: 100000, max: 125000, rate: 0.05 },
        { min: 125000, max: 150000, rate: 0.0525 },
        { min: 150000, max: 250000, rate: 0.055 },
        { min: 250000, max: Infinity, rate: 0.0575 }
      ],
      married: [
        { min: 0, max: 1000, rate: 0.02 },
        { min: 1000, max: 2000, rate: 0.03 },
        { min: 2000, max: 3000, rate: 0.04 },
        { min: 3000, max: 150000, rate: 0.0475 },
        { min: 150000, max: 175000, rate: 0.05 },
        { min: 175000, max: 225000, rate: 0.0525 },
        { min: 225000, max: 300000, rate: 0.055 },
        { min: 300000, max: Infinity, rate: 0.0575 }
      ]
    },
    standardDeduction: {
      single: 2550,
      married: 5100,
      headOfHousehold: 2550
    },
    exemptions: {
      personal: 3200,
      dependent: 3200
    },
    notes: 'Maryland has significant county/city taxes (2.25% - 3.2%)',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.009,
      pfmlEmployeeRate: 0.0045,
      pfmlEmployerRate: 0.0045,
      pfmlStartDate: '2025-07-01',
      localTaxCommon: true,
      localTaxType: 'county',
      localTaxRange: { min: 0.0225, max: 0.032 }
    }
  },
  MN: {
    name: 'Minnesota',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 31690, rate: 0.0535 },
        { min: 31690, max: 104090, rate: 0.068 },
        { min: 104090, max: 193240, rate: 0.0785 },
        { min: 193240, max: Infinity, rate: 0.0985 }
      ],
      married: [
        { min: 0, max: 46330, rate: 0.0535 },
        { min: 46330, max: 184040, rate: 0.068 },
        { min: 184040, max: 321450, rate: 0.0785 },
        { min: 321450, max: Infinity, rate: 0.0985 }
      ]
    },
    standardDeduction: {
      single: 14575,
      married: 29150,
      headOfHousehold: 21850
    },
    exemptions: {
      personal: 4800,
      dependent: 4800
    },
    notes: 'Minnesota has high top rate of 9.85%',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.008,
      pfmlEmployeeRate: 0.004,
      pfmlEmployerRate: 0.004,
      pfmlStartDate: '2026-01-01',
      localTaxCommon: false
    }
  },
  MO: {
    name: 'Missouri',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 1207, rate: 0.02 },
        { min: 1207, max: 2414, rate: 0.025 },
        { min: 2414, max: 3621, rate: 0.03 },
        { min: 3621, max: 4828, rate: 0.035 },
        { min: 4828, max: 6035, rate: 0.04 },
        { min: 6035, max: 7242, rate: 0.045 },
        { min: 7242, max: 8449, rate: 0.05 },
        { min: 8449, max: Infinity, rate: 0.048 } // Top rate reduced to 4.8%
      ],
      married: [
        { min: 0, max: 1207, rate: 0.02 },
        { min: 1207, max: 2414, rate: 0.025 },
        { min: 2414, max: 3621, rate: 0.03 },
        { min: 3621, max: 4828, rate: 0.035 },
        { min: 4828, max: 6035, rate: 0.04 },
        { min: 6035, max: 7242, rate: 0.045 },
        { min: 7242, max: 8449, rate: 0.05 },
        { min: 8449, max: Infinity, rate: 0.048 }
      ]
    },
    standardDeduction: {
      single: 14600, // Federal amount
      married: 29200
    },
    notes: 'Missouri allows federal tax deduction',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city earnings',
      localTaxRate: 0.01 // St. Louis, Kansas City
    }
  },
  NE: {
    name: 'Nebraska',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 3700, rate: 0.0246 },
        { min: 3700, max: 22170, rate: 0.0351 },
        { min: 22170, max: 35730, rate: 0.0501 },
        { min: 35730, max: Infinity, rate: 0.0584 }
      ],
      married: [
        { min: 0, max: 7390, rate: 0.0246 },
        { min: 7390, max: 44350, rate: 0.0351 },
        { min: 44350, max: 71460, rate: 0.0501 },
        { min: 71460, max: Infinity, rate: 0.0584 }
      ]
    },
    standardDeduction: {
      single: 7900,
      married: 15800,
      headOfHousehold: 11600
    },
    exemptions: {
      credit: 154 // Nebraska uses credits
    },
    notes: 'Nebraska four-bracket system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  NJ: {
    name: 'New Jersey',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 20000, rate: 0.014 },
        { min: 20000, max: 35000, rate: 0.0175 },
        { min: 35000, max: 40000, rate: 0.035 },
        { min: 40000, max: 75000, rate: 0.05525 },
        { min: 75000, max: 500000, rate: 0.0637 },
        { min: 500000, max: 1000000, rate: 0.0897 },
        { min: 1000000, max: Infinity, rate: 0.1075 }
      ],
      married: [
        { min: 0, max: 20000, rate: 0.014 },
        { min: 20000, max: 50000, rate: 0.0175 },
        { min: 50000, max: 70000, rate: 0.0245 },
        { min: 70000, max: 80000, rate: 0.035 },
        { min: 80000, max: 150000, rate: 0.05525 },
        { min: 150000, max: 500000, rate: 0.0637 },
        { min: 500000, max: 1000000, rate: 0.0897 },
        { min: 1000000, max: Infinity, rate: 0.1075 }
      ]
    },
    exemptions: {
      personal: 1000,
      dependent: 1500
    },
    notes: 'New Jersey has high top rate of 10.75%. No standard deduction.',
    otherTaxes: {
      sdiRequired: true,
      sdiRate: 0.0014,
      sdiWageBase: 161400,
      pfmlRequired: true,
      pfmlRate: 0.0006, // Family Leave Insurance (separate from TDI)
      pfmlWageBase: 161400,
      localTaxCommon: false
    }
  },
  NM: {
    name: 'New Mexico',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 5500, rate: 0.017 },
        { min: 5500, max: 11000, rate: 0.032 },
        { min: 11000, max: 16000, rate: 0.047 },
        { min: 16000, max: 210000, rate: 0.049 },
        { min: 210000, max: Infinity, rate: 0.059 }
      ],
      married: [
        { min: 0, max: 8000, rate: 0.017 },
        { min: 8000, max: 16000, rate: 0.032 },
        { min: 16000, max: 24000, rate: 0.047 },
        { min: 24000, max: 315000, rate: 0.049 },
        { min: 315000, max: Infinity, rate: 0.059 }
      ]
    },
    standardDeduction: {
      single: 14600,
      married: 29200,
      headOfHousehold: 21900
    },
    exemptions: {
      personal: 4500,
      dependent: 4500
    },
    notes: 'New Mexico five-bracket system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  NY: {
    name: 'New York',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 8500, rate: 0.04 },
        { min: 8500, max: 11700, rate: 0.045 },
        { min: 11700, max: 13900, rate: 0.0525 },
        { min: 13900, max: 80650, rate: 0.0585 },
        { min: 80650, max: 215400, rate: 0.0625 },
        { min: 215400, max: 1077550, rate: 0.0685 },
        { min: 1077550, max: 5000000, rate: 0.0965 },
        { min: 5000000, max: 25000000, rate: 0.103 },
        { min: 25000000, max: Infinity, rate: 0.109 }
      ],
      married: [
        { min: 0, max: 17150, rate: 0.04 },
        { min: 17150, max: 23600, rate: 0.045 },
        { min: 23600, max: 27900, rate: 0.0525 },
        { min: 27900, max: 161550, rate: 0.0585 },
        { min: 161550, max: 323200, rate: 0.0625 },
        { min: 323200, max: 2155350, rate: 0.0685 },
        { min: 2155350, max: 5000000, rate: 0.0965 },
        { min: 5000000, max: 25000000, rate: 0.103 },
        { min: 25000000, max: Infinity, rate: 0.109 }
      ]
    },
    standardDeduction: {
      single: 8000,
      married: 16050,
      headOfHousehold: 11200
    },
    exemptions: {
      dependent: 1000
    },
    notes: 'New York has NYC and Yonkers local taxes. Top rate 10.9%.',
    otherTaxes: {
      sdiRequired: true,
      sdiRate: 0.005,
      sdiWageBase: 13000, // Max weekly benefit based
      pfmlRequired: true,
      pfmlRate: 0.00455,
      pfmlWageBase: 89344, // 52 x state avg weekly wage
      localTaxCommon: true,
      localTaxType: 'NYC/Yonkers',
      nycRates: {
        single: [
          { min: 0, max: 12000, rate: 0.03078 },
          { min: 12000, max: 25000, rate: 0.03762 },
          { min: 25000, max: 50000, rate: 0.03819 },
          { min: 50000, max: Infinity, rate: 0.03876 }
        ]
      },
      yonkersRate: 0.1675 // 16.75% surcharge on state tax
    }
  },
  OH: {
    name: 'Ohio',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 26050, rate: 0 },
        { min: 26050, max: 100000, rate: 0.02765 },
        { min: 100000, max: Infinity, rate: 0.035 }
      ],
      married: [
        { min: 0, max: 26050, rate: 0 },
        { min: 26050, max: 100000, rate: 0.02765 },
        { min: 100000, max: Infinity, rate: 0.035 }
      ]
    },
    exemptions: {
      personal: 2400,
      dependent: 2400
    },
    notes: 'Ohio has 0% on first $26,050. Many cities have local income tax.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: true,
      localTaxType: 'city/RITA/CCA',
      localTaxRange: { min: 0.005, max: 0.03 }
    }
  },
  OK: {
    name: 'Oklahoma',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 1000, rate: 0.0025 },
        { min: 1000, max: 2500, rate: 0.0075 },
        { min: 2500, max: 3750, rate: 0.0175 },
        { min: 3750, max: 4900, rate: 0.0275 },
        { min: 4900, max: 7200, rate: 0.0375 },
        { min: 7200, max: Infinity, rate: 0.0475 }
      ],
      married: [
        { min: 0, max: 2000, rate: 0.0025 },
        { min: 2000, max: 5000, rate: 0.0075 },
        { min: 5000, max: 7500, rate: 0.0175 },
        { min: 7500, max: 9800, rate: 0.0275 },
        { min: 9800, max: 12200, rate: 0.0375 },
        { min: 12200, max: Infinity, rate: 0.0475 }
      ]
    },
    standardDeduction: {
      single: 6350,
      married: 12700,
      headOfHousehold: 9350
    },
    exemptions: {
      personal: 1000,
      dependent: 1000
    },
    notes: 'Oklahoma six-bracket progressive system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  OR: {
    name: 'Oregon',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 4050, rate: 0.0475 },
        { min: 4050, max: 10200, rate: 0.0675 },
        { min: 10200, max: 125000, rate: 0.0875 },
        { min: 125000, max: Infinity, rate: 0.099 }
      ],
      married: [
        { min: 0, max: 8100, rate: 0.0475 },
        { min: 8100, max: 20400, rate: 0.0675 },
        { min: 20400, max: 250000, rate: 0.0875 },
        { min: 250000, max: Infinity, rate: 0.099 }
      ]
    },
    standardDeduction: {
      single: 2605,
      married: 5210,
      headOfHousehold: 4195
    },
    exemptions: {
      credit: 236 // Oregon uses credit
    },
    notes: 'Oregon has no sales tax but high income tax. Uses federal taxable income.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.01,
      pfmlEmployeeRate: 0.006,
      pfmlEmployerRate: 0.004,
      pfmlWageBase: 168600,
      localTaxCommon: true,
      localTaxType: 'TriMet/LTD transit',
      localTaxRange: { min: 0.0076, max: 0.0082 }
    }
  },
  RI: {
    name: 'Rhode Island',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 73450, rate: 0.0375 },
        { min: 73450, max: 166950, rate: 0.0475 },
        { min: 166950, max: Infinity, rate: 0.0599 }
      ],
      married: [
        { min: 0, max: 73450, rate: 0.0375 },
        { min: 73450, max: 166950, rate: 0.0475 },
        { min: 166950, max: Infinity, rate: 0.0599 }
      ]
    },
    standardDeduction: {
      single: 10550,
      married: 21100,
      headOfHousehold: 15825
    },
    exemptions: {
      personal: 4700,
      dependent: 4700
    },
    notes: 'Rhode Island three-bracket system',
    otherTaxes: {
      sdiRequired: true,
      sdiRate: 0.012,
      sdiWageBase: 87300,
      pfmlRequired: false, // Part of TDI
      localTaxCommon: false
    }
  },
  SC: {
    name: 'South Carolina',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 3200, rate: 0 },
        { min: 3200, max: 16040, rate: 0.03 },
        { min: 16040, max: Infinity, rate: 0.064 }
      ],
      married: [
        { min: 0, max: 3200, rate: 0 },
        { min: 3200, max: 16040, rate: 0.03 },
        { min: 16040, max: Infinity, rate: 0.064 }
      ]
    },
    standardDeduction: {
      single: 14600, // Tied to federal
      married: 29200,
      headOfHousehold: 21900
    },
    exemptions: {
      personal: 2800,
      dependent: 4700
    },
    notes: 'South Carolina transitioning to lower rates. 0% on first $3,200.',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  VT: {
    name: 'Vermont',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 45400, rate: 0.0335 },
        { min: 45400, max: 110050, rate: 0.066 },
        { min: 110050, max: 229550, rate: 0.076 },
        { min: 229550, max: Infinity, rate: 0.0875 }
      ],
      married: [
        { min: 0, max: 75850, rate: 0.0335 },
        { min: 75850, max: 183400, rate: 0.066 },
        { min: 183400, max: 279450, rate: 0.076 },
        { min: 279450, max: Infinity, rate: 0.0875 }
      ]
    },
    standardDeduction: {
      single: 7000,
      married: 14000,
      headOfHousehold: 10500
    },
    exemptions: {
      personal: 4700,
      dependent: 4700
    },
    notes: 'Vermont uses federal AGI as starting point',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: true,
      pfmlRate: 0.0088,
      pfmlEmployeeRate: 0.0044,
      pfmlEmployerRate: 0.0044,
      pfmlStartDate: '2024-07-01',
      localTaxCommon: false
    }
  },
  VA: {
    name: 'Virginia',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 3000, rate: 0.02 },
        { min: 3000, max: 5000, rate: 0.03 },
        { min: 5000, max: 17000, rate: 0.05 },
        { min: 17000, max: Infinity, rate: 0.0575 }
      ],
      married: [
        { min: 0, max: 3000, rate: 0.02 },
        { min: 3000, max: 5000, rate: 0.03 },
        { min: 5000, max: 17000, rate: 0.05 },
        { min: 17000, max: Infinity, rate: 0.0575 }
      ]
    },
    standardDeduction: {
      single: 8500,
      married: 17000,
      headOfHousehold: 8500
    },
    exemptions: {
      personal: 930,
      dependent: 930
    },
    notes: 'Virginia four-bracket progressive system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  WV: {
    name: 'West Virginia',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 10000, rate: 0.0236 },
        { min: 10000, max: 25000, rate: 0.0315 },
        { min: 25000, max: 40000, rate: 0.0354 },
        { min: 40000, max: 60000, rate: 0.0472 },
        { min: 60000, max: Infinity, rate: 0.0512 }
      ],
      married: [
        { min: 0, max: 10000, rate: 0.0236 },
        { min: 10000, max: 25000, rate: 0.0315 },
        { min: 25000, max: 40000, rate: 0.0354 },
        { min: 40000, max: 60000, rate: 0.0472 },
        { min: 60000, max: Infinity, rate: 0.0512 }
      ]
    },
    exemptions: {
      personal: 2000,
      dependent: 2000
    },
    notes: 'West Virginia five-bracket progressive system',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  },
  WI: {
    name: 'Wisconsin',
    hasStateTax: true,
    taxType: 'progressive',
    brackets: {
      single: [
        { min: 0, max: 14320, rate: 0.035 },
        { min: 14320, max: 28640, rate: 0.044 },
        { min: 28640, max: 315310, rate: 0.053 },
        { min: 315310, max: Infinity, rate: 0.0765 }
      ],
      married: [
        { min: 0, max: 19090, rate: 0.035 },
        { min: 19090, max: 38190, rate: 0.044 },
        { min: 38190, max: 420420, rate: 0.053 },
        { min: 420420, max: Infinity, rate: 0.0765 }
      ]
    },
    standardDeduction: {
      single: 12760, // Sliding scale based on income
      married: 23620,
      headOfHousehold: 16990
    },
    exemptions: {
      personal: 700,
      dependent: 700
    },
    notes: 'Wisconsin standard deduction phases out at higher incomes',
    otherTaxes: {
      sdiRequired: false,
      pfmlRequired: false,
      localTaxCommon: false
    }
  }
};

// ============================================================================
// Helper Functions
// ============================================================================

/**
 * Get state by code
 */
export function getStateByCode(code) {
  return STATE_TAX_CONFIG[code] || null;
}

/**
 * Get all states that have income tax
 */
export function getStatesWithIncomeTax() {
  return Object.entries(STATE_TAX_CONFIG)
    .filter(([_, config]) => config.hasStateTax)
    .map(([code, config]) => ({
      code,
      name: config.name,
      taxType: config.taxType,
      topRate: config.flatRate || 
        (config.brackets?.single?.[config.brackets.single.length - 1]?.rate || 0)
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Get all states without income tax
 */
export function getStatesWithoutIncomeTax() {
  return Object.entries(STATE_TAX_CONFIG)
    .filter(([_, config]) => !config.hasStateTax)
    .map(([code, config]) => ({
      code,
      name: config.name,
      notes: config.notes
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Get states with local income tax
 */
export function getStatesWithLocalTax() {
  return Object.entries(STATE_TAX_CONFIG)
    .filter(([_, config]) => config.otherTaxes?.localTaxCommon)
    .map(([code, config]) => ({
      code,
      name: config.name,
      localTaxType: config.otherTaxes.localTaxType,
      localTaxRange: config.otherTaxes.localTaxRange || { min: 0, max: 0 }
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Get states with SDI (State Disability Insurance)
 */
export function getStatesWithSDI() {
  return Object.entries(STATE_TAX_CONFIG)
    .filter(([_, config]) => config.otherTaxes?.sdiRequired)
    .map(([code, config]) => ({
      code,
      name: config.name,
      sdiRate: config.otherTaxes.sdiRate,
      sdiWageBase: config.otherTaxes.sdiWageBase
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Get states with PFML (Paid Family Medical Leave)
 */
export function getStatesWithPFML() {
  return Object.entries(STATE_TAX_CONFIG)
    .filter(([_, config]) => config.otherTaxes?.pfmlRequired)
    .map(([code, config]) => ({
      code,
      name: config.name,
      pfmlRate: config.otherTaxes.pfmlRate,
      pfmlEmployeeRate: config.otherTaxes.pfmlEmployeeRate,
      pfmlEmployerRate: config.otherTaxes.pfmlEmployerRate,
      pfmlWageBase: config.otherTaxes.pfmlWageBase,
      pfmlStartDate: config.otherTaxes.pfmlStartDate
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Calculate state tax for given income
 */
export function calculateStateTaxFromConfig(
  annualTaxableIncome,
  stateCode,
  filingStatus = 'single',
  options = {}
) {
  const config = STATE_TAX_CONFIG[stateCode];
  if (!config || !config.hasStateTax) {
    return {
      tax: 0,
      effectiveRate: 0,
      stateName: config?.name || 'Unknown',
      hasStateTax: false
    };
  }

  let taxableIncome = annualTaxableIncome;

  // Apply standard deduction if applicable
  if (config.standardDeduction) {
    const deduction = config.standardDeduction[filingStatus] || 
      config.standardDeduction.single || 0;
    taxableIncome = Math.max(0, taxableIncome - deduction);
  }

  // Apply personal exemption if applicable
  if (config.exemptions?.personal) {
    const exemption = filingStatus === 'married' 
      ? (config.exemptions.personalMarried || config.exemptions.personal * 2)
      : config.exemptions.personal;
    taxableIncome = Math.max(0, taxableIncome - exemption);
  }

  // Apply dependent exemptions
  if (options.dependents && config.exemptions?.dependent) {
    taxableIncome = Math.max(0, taxableIncome - (options.dependents * config.exemptions.dependent));
  }

  let tax = 0;

  if (config.taxType === 'flat') {
    tax = taxableIncome * config.flatRate;

    // Apply additional tax for high earners (e.g., MA millionaires tax)
    if (config.additionalRate && taxableIncome > config.additionalThreshold) {
      tax += (taxableIncome - config.additionalThreshold) * config.additionalRate;
    }
  } else if (config.taxType === 'progressive' && config.brackets) {
    const brackets = config.brackets[filingStatus] || config.brackets.single;
    let remainingIncome = taxableIncome;

    for (const bracket of brackets) {
      if (remainingIncome <= 0) break;
      
      const taxableInBracket = Math.min(
        remainingIncome, 
        (bracket.max === Infinity ? remainingIncome : bracket.max - bracket.min)
      );
      tax += taxableInBracket * bracket.rate;
      remainingIncome -= taxableInBracket;
    }
  }

  // Apply exemption credits if applicable (some states use credits instead)
  if (config.exemptions?.credit) {
    tax = Math.max(0, tax - config.exemptions.credit);
  }

  const effectiveRate = annualTaxableIncome > 0 
    ? (tax / annualTaxableIncome) * 100 
    : 0;

  return {
    tax: Math.round(tax * 100) / 100,
    effectiveRate: effectiveRate.toFixed(2),
    marginalRate: config.flatRate 
      ? config.flatRate * 100 
      : getBracketRate(taxableIncome, config.brackets?.[filingStatus] || config.brackets?.single) * 100,
    stateName: config.name,
    hasStateTax: true,
    taxType: config.taxType,
    standardDeduction: config.standardDeduction?.[filingStatus] || 0
  };
}

/**
 * Get marginal bracket rate for income level
 */
function getBracketRate(income, brackets) {
  if (!brackets) return 0;
  for (const bracket of brackets) {
    if (income <= bracket.max) {
      return bracket.rate;
    }
  }
  return brackets[brackets.length - 1]?.rate || 0;
}

/**
 * Get all states as dropdown options
 */
export function getStateDropdownOptions() {
  return Object.entries(US_STATES)
    .map(([code, state]) => ({
      code: code,
      name: state.name,
      value: code,
      label: state.name,
      hasStateTax: STATE_TAX_CONFIG[code]?.hasStateTax || false
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export default {
  US_STATES,
  STATE_TAX_CONFIG,
  getStateByCode,
  getStatesWithIncomeTax,
  getStatesWithoutIncomeTax,
  getStatesWithLocalTax,
  getStatesWithSDI,
  getStatesWithPFML,
  calculateStateTaxFromConfig,
  getStateDropdownOptions
};
